var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Emit, Inject, Vue, } from "vue-property-decorator";
import { isArray, isInputEntry, } from "./utilities/wsi4_typeguards";
import { defaultConfig, isConfiguration, RequestType, } from "./utilities/configuration";
function createRequest(key, params) {
    return JSON.stringify({
        modulePath: "src/external_api_shop.js",
        functionName: "callApiFunction",
        args: [
            key,
            JSON.stringify(params),
        ],
    });
}
function toErrorMessage(text) {
    return {
        tag: "ErrorMessage",
        message: text,
    };
}
export default class NetworkBroker extends Vue {
    constructor() {
        super(...arguments);
        this.busy = false;
        this.configuration = defaultConfig;
        this.graphNodeIds = [];
        this.requestQueue = [];
        this.url = "/";
    }
    finished(status) { return status; }
    requestFinished(request) { return request; }
    error(err) {
        return err;
    }
    save() { }
    request() { }
    closeReadOnlyView() { }
    showInfo(key) { return key; }
    prepareSave() { }
    saveGraph() { }
    configurationChanged() { }
    showMessageHelp(key) { return key; }
    queueRequest(type, body) {
        if (this.busy) {
            return false;
        }
        this.requestQueue.push({
            type: type,
            body: body,
        });
        return true;
    }
    process() {
        if (this.busy) {
            return false;
        }
        const request = this.requestQueue[0];
        if (this.requestQueue.length > 0) {
            this.finished(false);
            this.busy = true;
            this.postRequest(request.type, request.body);
        }
        else {
            this.requestFinished(request);
            this.finished(true);
        }
        return true;
    }
    onFinished() {
        if (!this.busy) {
            return;
        }
        this.requestQueue.shift();
        this.busy = false;
        this.process();
    }
    onError() {
        if (!this.busy) {
            return;
        }
        this.requestQueue.shift();
        this.busy = false;
    }
    postRequest(type, body) {
        if (!this.busy) {
            return;
        }
        const rq = new XMLHttpRequest();
        rq.onreadystatechange = function (vm, type) {
            if (this.readyState === XMLHttpRequest.DONE) {
                if (this.status === 200) {
                    const obj = vm.configuration.resultFunction(rq);
                    if (obj === undefined) {
                        vm.onError();
                        vm.error(toErrorMessage("Error parsing request response"));
                    }
                    if (obj.finished) {
                        if (obj.data.type === "Success") {
                            vm.onFinished();
                            vm.$emit(type, obj.data.return);
                        }
                        else {
                            vm.onError();
                            vm.error(toErrorMessage(obj.data.error));
                        }
                    }
                    else {
                        vm.configuration.updateFunction(vm, type);
                    }
                }
                else {
                    vm.onError();
                    vm.error(toErrorMessage("Http request error " + this.status.toString()));
                }
            }
        }.bind(rq, this, type, body);
        rq.open("POST", this.url, true);
        this.configuration.headerFunction(rq);
        rq.send(body);
    }
    queueAddDataRequest(inputEntries) {
        if (!isArray(inputEntries, isInputEntry)) {
            throw Error("Wrong type: needed Array<InputEntry>");
        }
        return this.queueRequest(RequestType.filesChanged, createRequest("addData", [inputEntries]));
    }
    queueAddLayeredsRequest(twoDimInputs) { return this.queueRequest(RequestType.filesChanged, createRequest("addLayereds", [twoDimInputs])); }
    queueConfigRequest() {
        return this.queueRequest(RequestType.configChanged, createRequest("shopConfiguration", [
            {
                tubesEnabled: this.configuration.partCreationConfig.userDefinedTube,
            },
        ]));
    }
    queueGraphRequest() {
        this.saveGraph();
        return this.queueRequest(RequestType.graphChanged, createRequest("createProjectObject", [this.graphNodeIds]));
    }
    queueClearGraphRequest() { return this.queueRequest(RequestType.clearGraph, createRequest("clearGraph", [])); }
    queueDeleteRequest(vertexKeyArray) { return this.queueRequest(RequestType.deleteArticle, createRequest("deleteNodes", [vertexKeyArray])); }
    queueDisassembleRequest(vertexId) { return this.queueRequest(RequestType.disassembleArticle, createRequest("deleteNodes", [[vertexId]])); }
    queueProjectNameRequest(name) { return this.queueRequest(RequestType.changeProjectName, createRequest("changeProjectName", [name])); }
    queueChangeAttributesRequest(vertexDataArray) {
        return this.queueRequest(RequestType.changeNodesData, createRequest("applyChangesToVertices", [vertexDataArray]));
    }
    queueAddSimplePartRequest(p) { return this.queueRequest(RequestType.addSimplePart, createRequest("addSimplePart", [p])); }
    queueAddUserDefinedTubeRequest(t) {
        return this.queueRequest(RequestType.addUserDefinedTube, createRequest("addUserDefinedTube", [
            t.tubeId,
            t.dimX,
            t.name,
        ]));
    }
    setup(configuration = defaultConfig) {
        this.setConfiguration(configuration);
        this.queueConfigRequest();
        this.queueGraphRequest();
        this.process();
    }
    addSlot(type, f) { this.$on(type, f); }
    setConfiguration(configuration) {
        if (!isConfiguration(configuration)) {
            throw Error("\"configuration\" has wrong type.");
        }
        this.configuration = configuration;
        this.configurationChanged();
    }
}
__decorate([
    Inject()
], NetworkBroker.prototype, "i18n", void 0);
__decorate([
    Emit()
], NetworkBroker.prototype, "finished", null);
__decorate([
    Emit()
], NetworkBroker.prototype, "requestFinished", null);
__decorate([
    Emit()
], NetworkBroker.prototype, "error", null);
__decorate([
    Emit()
], NetworkBroker.prototype, "save", null);
__decorate([
    Emit()
], NetworkBroker.prototype, "request", null);
__decorate([
    Emit()
], NetworkBroker.prototype, "closeReadOnlyView", null);
__decorate([
    Emit()
], NetworkBroker.prototype, "showInfo", null);
__decorate([
    Emit()
], NetworkBroker.prototype, "prepareSave", null);
__decorate([
    Emit()
], NetworkBroker.prototype, "saveGraph", null);
__decorate([
    Emit()
], NetworkBroker.prototype, "configurationChanged", null);
__decorate([
    Emit()
], NetworkBroker.prototype, "showMessageHelp", null);
